import React from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Toast = {
    success: (message, options = {}) => toast.success(message, { ...options }),
    error: (message, options = {}) => toast.error(message, { ...options }),
    warning: (message, options = {}) => toast.warning(message, { ...options }),
    info: (message, options = {}) => toast.info(message, { ...options }),
    default: (message, options = {}) => toast(message, { ...options }),
};

export { Toast, ToastContainer };